import {connect} from '@modifi/redux'
import {aPush} from '@modifi/router'
import {compose} from 'ramda'
import {withSuspense} from '@modifi/plugin-onboarding'
import {FeInputFieldStatus} from '@modifi/enums'
import {
  selectBeneficialOwnerByExternalId,
  selectBeneficialOwnerNameByExternalId,
} from '../../../../data/beneficial-owners'
import ExistingBeneficialOwner, {ExistingBeneficialOwnerProps} from './ExistingBeneficialOwner'
import {
  aInitializePage,
  aReset,
  aSavePage,
  selectInitialFormDataForEditing,
  selectInitializePagePending,
  selectSaveErrorMessage,
  selectSaveHasError,
  selectSavePending,
} from '../store/form'
import {selectCombinedInputFieldStatusBySectionName} from '../../../../modules/input-fields'
import {SECTION_ULTIMATE_BENEFICIAL_OWNERS} from '../../../../constants/sections'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapStateToProps = (
  state: Record<string, any>,
  ownProps: Record<string, any>
): Pick<
  ExistingBeneficialOwnerProps,
  | 'externalPersonId'
  | 'isLoading'
  | 'isValidPersonId'
  | 'updatePending'
  | 'formData'
  | 'hasError'
  | 'errorMessage'
  | 'pageIsVerified'
  | 'uboName'
> => {
  const externalPersonId = ownProps?.match?.params?.externalId

  const isLoading = selectInitializePagePending(state, externalPersonId)
  return {
    externalPersonId,
    isLoading,
    isValidPersonId:
      isLoading ||
      selectBeneficialOwnerByExternalId(state, externalPersonId)?.externalId === externalPersonId,
    updatePending: selectSavePending(state),
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    formData: selectInitialFormDataForEditing(state, externalPersonId!),
    hasError: selectSaveHasError(state),
    errorMessage: selectSaveErrorMessage(state),
    pageIsVerified:
      selectCombinedInputFieldStatusBySectionName(state, SECTION_ULTIMATE_BENEFICIAL_OWNERS) ===
      FeInputFieldStatus.VERIFIED,
    uboName: selectBeneficialOwnerNameByExternalId(state, externalPersonId),
  }
}

const mapDispatchToProps = {
  initialize: aInitializePage,
  onSubmit: aSavePage,
  onDiscard: aReset,
  redirect: aPush,
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  withSuspense(false)(ExistingBeneficialOwner)
)
